<template>
    <div class="icon-picker">
      <div v-if="isModal()">
        <b-btn @click="modalShow = !modalShow" variant="secondary" :size="size"><span v-if="icon !== null"><img class="button-icon" :src="icon.location" :alt="icon.text" :title="icon.text">Zmień</span><span v-else>Ustaw</span></b-btn>
        <b-modal v-model="modalShow" size="lg" title="Wybór ikony" ref="iconModal">
            <div class="icon-picker-container">
                <ul>
                    <li v-for="iconOption in icons" :key="iconOption.location">
                        <div class="icon-picker-element text-center" v-bind:class="{ selected: iconOption == selectedIcon }" @click="selectIcon(iconOption)" v-on:keyup.enter="selectIcon(iconOption)" tabindex="0" :title="'Zaznacz, aby wybrać ikonę ' + iconOption.text">
                            <img class="icon-element" :src="iconOption.location" :alt="iconOption.text">
                        </div>
                    </li>
                </ul>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" @click="save">Potwierdź</b-btn>
                <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
            </div>
        </b-modal>
      </div>
        <div v-else>
          <b-dropdown text="Ustaw" boundary="window" menu-class="icon-dropdown">
            <template slot="button-content">
                <span v-if="icon !== null">
                  <img class="button-icon" :src="icon.location" :alt="icon.text" :title="icon.text">Zmień
                </span>
                <span v-else>Ustaw</span>
            </template>
            <b-dropdown-header>Zaznacz, aby wybrać ikonę</b-dropdown-header>
            <b-dropdown-item v-for="icon in icons" :key="icon.location" @click="selectIcon(icon)">
              <img class="mr-3" width="25" height="25" :src="icon.location" :alt="icon.text">{{ icon.text }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
export default {
    name: "IconPicker",
    components:{
        VueScrollTo
    },
    props: { 
      value: String,
      size: String,
      type: { 
        type: String,
        default: 'modal',
        validator: (value) => ['modal', 'dropdown'].indexOf(value) !== -1
      }
    },
    data () {
        return {
            id: "",
            icon: null,
            selectedIcon: null,
            modalShow: false,
            icons: 
            [
                { name: "airport-14.png", location: require("../assets/icons/airport-14.png"), text: "Samolot" },
                { name: "alcohol-14.png", location: require("../assets/icons/alcohol-14.png"), text: "Alkohol" },
                { name: "alpine-hut-14.png", location: require("../assets/icons/alpine-hut-14.png"), text: "Domek letniskowy" },
                { name: "archaeological-site-14.png", location: require("../assets/icons/archaeological-site-14.png"), text: "Miejsce archeologiczne" },
                { name: "atm-14.png", location: require("../assets/icons/atm-14.png"), text: "Bankomat" },
                { name: "bakery-14.png", location: require("../assets/icons/bakery-14.png"), text: "Piekarnia" },
                { name: "bank-14.png", location: require("../assets/icons/bank-14.png"), text: "Bank" },
                { name: "bar-14.png", location: require("../assets/icons/bar-14.png"), text: "Bar" },
                { name: "basic-hut-14.png", location: require("../assets/icons/basic-hut-14.png"), text: "Chatka" },
                { name: "beauty-14.png", location: require("../assets/icons/beauty-14.png"), text: "Piękno" },
                { name: "bench-14.png", location: require("../assets/icons/bench-14.png"), text: "Ławka" },
                { name: "beverages-14.png", location: require("../assets/icons/beverages-14.png"), text: "Napoje" },
                { name: "bicycle-14.png", location: require("../assets/icons/bicycle-14.png"), text: "Rower" },
                { name: "biergarten-14.png", location: require("../assets/icons/biergarten-14.png"), text: "Ogródek piwny" },
                { name: "bollard-10.png", location: require("../assets/icons/bollard-10.png"), text: "Pachołek" },
                { name: "bollard-14.png", location: require("../assets/icons/bollard-14.png"), text: "Pachołek" },
                { name: "books-14.png", location: require("../assets/icons/books-14.png"), text: "Książki" },
                { name: "buddhist-14.png", location: require("../assets/icons/buddhist-14.png"), text: "Koło dharmy" },
                { name: "bus-station-14.png", location: require("../assets/icons/bus-station-14.png"), text: "Dworzec autobusowy" },
                { name: "bus-stop-10.png", location: require("../assets/icons/bus-stop-10.png"), text: "Przystanek autobusowy" },
                { name: "bus-stop-14.png", location: require("../assets/icons/bus-stop-14.png"), text: "Przystanek autobusowy" },
                { name: "butcher-14.png", location: require("../assets/icons/butcher-14.png"), text: "Rzeźnik" },
                { name: "cafe-14.png", location: require("../assets/icons/cafe-14.png"), text: "Kawiarnia" },
                { name: "camping-14.png", location: require("../assets/icons/camping-14.png"), text: "Kemping" },
                { name: "car-14.png", location: require("../assets/icons/car-14.png"), text: "Samochód" },
                { name: "car-parts-14.png", location: require("../assets/icons/car-parts-14.png"), text: "Części samochodowe" },
                { name: "caravan-14.png", location: require("../assets/icons/caravan-14.png"), text: "Przyczepa turystyczna" },
                { name: "castle-defensive-14.png", location: require("../assets/icons/castle-defensive-14.png"), text: "Zamek obronny" },
                { name: "castle-fortress-14.png", location: require("../assets/icons/castle-fortress-14.png"), text: "Zamek twierdza" },
                { name: "castle-manor-14.png", location: require("../assets/icons/castle-manor-14.png"), text: "Zamek dwór" },
                { name: "castle-palace-14.png", location: require("../assets/icons/castle-palace-14.png"), text: "Zamek pałac" },
                { name: "castle-stately-14.png", location: require("../assets/icons/castle-stately-14.png"), text: "Okazały zamek" },
                { name: "cattle-grid-10.png", location: require("../assets/icons/cattle-grid-10.png"), text: "Przeszkoda dla bydła" },
                { name: "cattle-grid-14.png", location: require("../assets/icons/cattle-grid-14.png"), text: "Przeszkoda dla bydła" },
                { name: "cemetery-14.png", location: require("../assets/icons/cemetery-14.png"), text: "Cmentarz" },
                { name: "charging-station-14.png", location: require("../assets/icons/charging-station-14.png"), text: "Stacja ładoowania" },
                { name: "chemist-14.png", location: require("../assets/icons/chemist-14.png"), text: "Aptekarz" },
                { name: "christian-14.png", location: require("../assets/icons/christian-14.png"), text: "Krzyż" },
                { name: "christian-orthodox-14.png", location: require("../assets/icons/christian-orthodox-14.png"), text: "Krzyż prawosławny" },
                { name: "cinema-14.png", location: require("../assets/icons/cinema-14.png"), text: "Kino" },
                { name: "city-gate-14.png", location: require("../assets/icons/city-gate-14.png"), text: "Brama miasta" },
                { name: "clock-14.png", location: require("../assets/icons/clock-14.png"), text: "Zegar" },
                { name: "clothes-14.png", location: require("../assets/icons/clothes-14.png"), text: "Ubranie" },
                { name: "computer-14.png", location: require("../assets/icons/computer-14.png"), text: "Komputer" },
                { name: "confectionery-14.png", location: require("../assets/icons/confectionery-14.png"), text: "Cukiernia" },
                { name: "convenience-14.png", location: require("../assets/icons/convenience-14.png"), text: "Sklep" },
                { name: "copyshop-14.png", location: require("../assets/icons/copyshop-14.png"), text: "Ksero" },
                { name: "courthouse-10.png", location: require("../assets/icons/courthouse-10.png"), text: "Sąd" },
                { name: "courthouse-14.png", location: require("../assets/icons/courthouse-14.png"), text: "Sąd" },
                { name: "dentist-14.png", location: require("../assets/icons/dentist-14.png"), text: "Dentysta" },
                { name: "doctor-14.png", location: require("../assets/icons/doctor-14.png"), text: "Doktor" },
                { name: "doityourself-14.png", location: require("../assets/icons/doityourself-14.png"), text: "Narzędzia" },
                { name: "drinking-water-14.png", location: require("../assets/icons/drinking-water-14.png"), text: "Wodopój" },
                { name: "electronics-14.png", location: require("../assets/icons/electronics-14.png"), text: "Elektronika" },
                { name: "elevator-14.png", location: require("../assets/icons/elevator-14.png"), text: "Winda" },
                { name: "embassy-10.png", location: require("../assets/icons/embassy-10.png"), text: "Flaga" },
                { name: "embassy-14.png", location: require("../assets/icons/embassy-14.png"), text: "Flaga" },
                { name: "emergency-phone-14.png", location: require("../assets/icons/emergency-phone-14.png"), text: "Telefon alarmowy" },
                { name: "entrance-10.png", location: require("../assets/icons/entrance-10.png"), text: "Wejście" },
                { name: "entrance-14.png", location: require("../assets/icons/entrance-14.png"), text: "Wejście" },
                { name: "exit-10.png", location: require("../assets/icons/exit-10.png"), text: "Wyjście" },
                { name: "exit-14.png", location: require("../assets/icons/exit-14.png"), text: "Wyjście" },
                { name: "fast-food-14.png", location: require("../assets/icons/fast-food-14.png"), text: "Fast food" },
                { name: "ferry-14.png", location: require("../assets/icons/ferry-14.png"), text: "Prom" },
                { name: "fire-station-14.png", location: require("../assets/icons/fire-station-14.png"), text: "Straż pożarna" },
                { name: "florist-14.png", location: require("../assets/icons/florist-14.png"), text: "Kwiaciarnia" },
                { name: "ford-14.png", location: require("../assets/icons/ford-14.png"), text: "Przeprawa" },
                { name: "fort-14.png", location: require("../assets/icons/fort-14.png"), text: "Fort" },
                { name: "fountain-14.png", location: require("../assets/icons/fountain-14.png"), text: "Fontanna" },
                { name: "fuel-14.png", location: require("../assets/icons/fuel-14.png"), text: "Stacja paliw" },
                { name: "furniture-14.png", location: require("../assets/icons/furniture-14.png"), text: "Meble" },
                { name: "garden-centre-14.png", location: require("../assets/icons/garden-centre-14.png"), text: "Narzędzia ogrodowe" },
                { name: "gate-10.png", location: require("../assets/icons/gate-10.png"), text: "Brama" },
                { name: "gate-14.png", location: require("../assets/icons/gate-14.png"), text: "Brama" },
                { name: "gift-14.png", location: require("../assets/icons/gift-14.png"), text: "Prezent" },
                { name: "government-14.png", location: require("../assets/icons/government-14.png"), text: "Rząd" },
                { name: "greengrocer-14.png", location: require("../assets/icons/greengrocer-14.png"), text: "Sklep ważywny" },
                { name: "guidepost-14.png", location: require("../assets/icons/guidepost-14.png"), text: "Drogowskaz" },
                { name: "hairdresser-14.png", location: require("../assets/icons/hairdresser-14.png"), text: "Fryzjer" },
                { name: "heliport-14.png", location: require("../assets/icons/heliport-14.png"), text: "Lądowisko dla helikopterów" },
                { name: "hifi-14.png", location: require("../assets/icons/hifi-14.png"), text: "Sprzęt audio" },
                { name: "hinduist-14.png", location: require("../assets/icons/hinduist-14.png"), text: "Symbol hinduizmu" },
                { name: "hospital-14.png", location: require("../assets/icons/hospital-14.png"), text: "Szpital" },
                { name: "hostel-14.png", location: require("../assets/icons/hostel-14.png"), text: "Hostel" },
                { name: "hotel-14.png", location: require("../assets/icons/hotel-14.png"), text: "Hotel" },
                { name: "hunting-stand-14.png", location: require("../assets/icons/hunting-stand-14.png"), text: "Stanowisko myśliwskie" },
                { name: "ice-cream-14.png", location: require("../assets/icons/ice-cream-14.png"), text: "Lody" },
                { name: "information-14.png", location: require("../assets/icons/information-14.png"), text: "Informacja" },
                { name: "jewellery-14.png", location: require("../assets/icons/jewellery-14.png"), text: "Jubiler" },
                { name: "jewish-14.png", location: require("../assets/icons/jewish-14.png"), text: "Gwiazda Dawida" },
                { name: "kiosk-14.png", location: require("../assets/icons/kiosk-14.png"), text: "Kiosk" },
                { name: "laundry-14.png", location: require("../assets/icons/laundry-14.png"), text: "Pralnia" },
                { name: "library-14.png", location: require("../assets/icons/library-14.png"), text: "Biblioteka" },
                { name: "lift-gate-10.png", location: require("../assets/icons/lift-gate-10.png"), text: "Podnośnik" },
                { name: "lift-gate-14.png", location: require("../assets/icons/lift-gate-14.png"), text: "Podnośnik" },
                { name: "lighthouse-14.png", location: require("../assets/icons/lighthouse-14.png"), text: "Latarnia" },
                { name: "luggage-14.png", location: require("../assets/icons/luggage-14.png"), text: "Bagaż" },
                { name: "mast-14.png", location: require("../assets/icons/mast-14.png"), text: "Maszt" },
                { name: "mast-communications-14.png", location: require("../assets/icons/mast-communications-14.png"), text: "Maszt komunikacyjny" },
                { name: "memorial-10.png", location: require("../assets/icons/memorial-10.png"), text: "Memoriał" },
                { name: "memorial-14.png", location: require("../assets/icons/memorial-14.png"), text: "Memoriał" },
                { name: "metro-14.png", location: require("../assets/icons/metro-14.png"), text: "Metro" },
                { name: "mobile-phone-14.png", location: require("../assets/icons/mobile-phone-14.png"), text: "Telefon komórkowy" },
                { name: "monument-14.png", location: require("../assets/icons/monument-14.png"), text: "Pomnik" },
                { name: "motel-14.png", location: require("../assets/icons/motel-14.png"), text: "Model" },
                { name: "museum-14.png", location: require("../assets/icons/museum-14.png"), text: "Muzeum" },
                { name: "muslim-14.png", location: require("../assets/icons/muslim-14.png"), text: "Symbol islamu" },
                { name: "news-14.png", location: require("../assets/icons/news-14.png"), text: "Aktualności" },
                { name: "nightclub-14.png", location: require("../assets/icons/nightclub-14.png"), text: "Klub nony" },
                { name: "optician-14.png", location: require("../assets/icons/optician-14.png"), text: "Optyk" },
                { name: "parking-bicycle-14.png", location: require("../assets/icons/parking-bicycle-14.png"), text: "Parking rowerowy" },
                { name: "parking-car-14.png", location: require("../assets/icons/parking-car-14.png"), text: "Parking samochodowy" },
                { name: "parking-garage-car-14.png", location: require("../assets/icons/parking-garage-car-14.png"), text: "Zadaszony parking samochodowy" },
                { name: "peak-10.png", location: require("../assets/icons/peak-10.png"), text: "Szczyt" },
                { name: "peak-14.png", location: require("../assets/icons/peak-14.png"), text: "Szczyt" },
                { name: "pet-14.png", location: require("../assets/icons/pet-14.png"), text: "Zwierzę domowe" },
                { name: "pharmacy-14.png", location: require("../assets/icons/pharmacy-14.png"), text: "Apteka" },
                { name: "photo-14.png", location: require("../assets/icons/photo-14.png"), text: "Fotografia" },
                { name: "place-of-worship-14.png", location: require("../assets/icons/place-of-worship-14.png"), text: "Miejsce kultu" },
                { name: "playground-14.png", location: require("../assets/icons/playground-14.png"), text: "Plac zabaw" },
                { name: "police-14.png", location: require("../assets/icons/police-14.png"), text: "Policja" },
                { name: "post-office-10.png", location: require("../assets/icons/post-office-10.png"), text: "Poczta" },
                { name: "post-office-14.png", location: require("../assets/icons/post-office-14.png"), text: "Poczta" },
                { name: "power-wind-14.png", location: require("../assets/icons/power-wind-14.png"), text: "Elektrownia wiatrowa" },
                { name: "prison-14.png", location: require("../assets/icons/prison-14.png"), text: "Więzienie" },
                { name: "pub-14.png", location: require("../assets/icons/pub-14.png"), text: "Pub" },
                { name: "railway-halt-14.png", location: require("../assets/icons/railway-halt-14.png"), text: "Przystanek kolejowy" },
                { name: "railway-station-14.png", location: require("../assets/icons/railway-station-14.png"), text: "Stacja kolejowa" },
                { name: "recycling-14.png", location: require("../assets/icons/recycling-14.png"), text: "Recykling" },
                { name: "rental-bicycle-14.png", location: require("../assets/icons/rental-bicycle-14.png"), text: "Wypożyczalnia rowerów" },
                { name: "rental-car-14.png", location: require("../assets/icons/rental-car-14.png"), text: "Wypożyczalnia samochodów" },
                { name: "repair-bicycle-14.png", location: require("../assets/icons/repair-bicycle-14.png"), text: "Naprawa rowerów" },
                { name: "repair-car-14.png", location: require("../assets/icons/repair-car-14.png"), text: "Naprawa samochodów" },
                { name: "restaurant-14.png", location: require("../assets/icons/restaurant-14.png"), text: "Restauracja" },
                { name: "saddle-10.png", location: require("../assets/icons/saddle-10.png"), text: "Siodło" },
                { name: "saddle-14.png", location: require("../assets/icons/saddle-14.png"), text: "Siodło" },
                { name: "shared-car-14.png", location: require("../assets/icons/shared-car-14.png"), text: "Współdzienie auta" },
                { name: "shelter-14.png", location: require("../assets/icons/shelter-14.png"), text: "Schronienie" },
                { name: "shintoist-14.png", location: require("../assets/icons/shintoist-14.png"), text: "Symbol szintoizmu" },
                { name: "shoes-14.png", location: require("../assets/icons/shoes-14.png"), text: "Buty" },
                { name: "sikhist-14.png", location: require("../assets/icons/sikhist-14.png"), text: "Symbol sikhizmu" },
                { name: "spring-14.png", location: require("../assets/icons/spring-14.png"), text: "Wiosna" },
                { name: "stationery-14.png", location: require("../assets/icons/stationery-14.png"), text: "Artykuły papiernicze" },
                { name: "steps-10.png", location: require("../assets/icons/steps-10.png"), text: "Schody" },
                { name: "steps-14.png", location: require("../assets/icons/steps-14.png"), text: "Schody" },
                { name: "supermarket-14.png", location: require("../assets/icons/supermarket-14.png"), text: "Supermarket" },
                { name: "swimming-14.png", location: require("../assets/icons/swimming-14.png"), text: "Pływalnia" },
                { name: "table-14.png", location: require("../assets/icons/table-14.png"), text: "Stół" },
                { name: "taoist-14.png", location: require("../assets/icons/taoist-14.png"), text: "SYmbol taoizmu" },
                { name: "taxi-14.png", location: require("../assets/icons/taxi-14.png"), text: "Postój taxi" },
                { name: "telephone-14.png", location: require("../assets/icons/telephone-14.png"), text: "Telefon" },
                { name: "theatre-14.png", location: require("../assets/icons/theatre-14.png"), text: "Teatr" },
                { name: "toilets-14.png", location: require("../assets/icons/toilets-14.png"), text: "Toalety" },
                { name: "town-hall-14.png", location: require("../assets/icons/town-hall-14.png"), text: "Ratusz" },
                { name: "toys-14.png", location: require("../assets/icons/toys-14.png"), text: "Zabawki" },
                { name: "tram-stop-14.png", location: require("../assets/icons/tram-stop-14.png"), text: "Przystanek tramwajowy" },
                { name: "tree-coniferous-14.png", location: require("../assets/icons/tree-coniferous-14.png"), text: "Drzewo iglaste" },
                { name: "tree-deciduous-14.png", location: require("../assets/icons/tree-deciduous-14.png"), text: "Drzewo liściaste" },
                { name: "tree-unspecified-14.png", location: require("../assets/icons/tree-unspecified-14.png"), text: "Drzewo nieokreślone" },
                { name: "veterinary-14.png", location: require("../assets/icons/veterinary-14.png"), text: "Weterynaryjny" },
                { name: "viewpoint-14.png", location: require("../assets/icons/viewpoint-14.png"), text: "Punkt widokowy" },
                { name: "waste-basket-10.png", location: require("../assets/icons/waste-basket-10.png"), text: "Kosz na śmieci" },
                { name: "waste-basket-14.png", location: require("../assets/icons/waste-basket-14.png"), text: "Kosz na śmieci" },
                { name: "watchtower-14.png", location: require("../assets/icons/watchtower-14.png"), text: "Wieża widokowa" },
                { name: "water-tower-14.png", location: require("../assets/icons/water-tower-14.png"), text: "Wieża ciśnień" },
                { name: "waterfall-14.png", location: require("../assets/icons/waterfall-14.png"), text: "Wodospad" },
                { name: "wilderness-hut-14.png", location: require("../assets/icons/wilderness-hut-14.png"), text: "Gajówka" },
                { name: "windmill-14.png", location: require("../assets/icons/windmill-14.png"), text: "Wiatrak" }
            ]
        }
    },
    mounted() {
        this.id = 'modal-icon-' + this._uid.toString();
        let modelIcon = null;
        if(this.value != null && this.value.length !== 0){
            let buffIcon = this.icons.filter(x => x.location === this.value); 
            if(buffIcon != null && buffIcon.length !== 0){
                modelIcon = buffIcon[0];
            }
        }
        this.icon = modelIcon;
        this.selectedIcon = modelIcon;
    },
    methods: {
        updateValue(){
            this.$emit('input', this.icon.location);
        },
        iconLocation(icon){
            return icon.location;
        },
        selectIcon(icon){
            if(this.selectedIcon != icon){
                this.selectedIcon = icon;
            } else {
                this.selectedIcon = null;
            }

            if (!this.isModal()) {
              this.save();
            }
        },
        save() {
            this.icon = this.selectedIcon;
            this.updateValue();
        },
        hide() {
            this.$refs.iconModal.hide();
        },
        isModal() {
          return this.type === 'modal';
        }
    },
  }
</script>
<style>
.icon-picker-container ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.icon-picker-container li {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 8%;
    flex: 0 0 8;
    margin-right: 0.3%;
    margin-top: 0.5%;
}

.icon-picker.is-invalid > .btn {
    border-color: #dc3545;
}

.icon-picker.is-invalid > .btn:hover, .icon-picker.is-invalid > .btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.icon-picker-element {
    border: 1px solid #eee;
    border-radius: 0.25rem;
}
.icon-picker-element:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.icon-picker-element.selected {
    border-color: #b8daff;
    background-color: #cce5ff;
}
.icon-picker-element .icon-element {
    width: 25px; 
    height: 25px;
    margin-top: 5px; 
    margin-bottom: 5px;
}
.button-icon {
    height: 24px;
    margin-right: 8px;
    margin-top: -5px;
}
@media (max-width: 767.98px) {
    .icon-picker-container li {
        width: 12%;
        flex: 0 0 12;
        margin-right: 0.5%;
        margin-top: 0.75%;
    }
}

.icon-dropdown {
  max-height: 25vh;
  overflow-y: auto;
}
</style>